/**
 * Sample placement data for PlacementTracker.
 * TODO: Replace with API response in component layer.
 */
import type { PlacementData } from './PlacementTracker';

export const sampleData: PlacementData = {
  candidate: {
    id: 'c1',
    firstName: 'Sarah',
    lastName: 'Mitchell',
    title: 'Registered Nurse - ICU/ER Specialist',
    email: 'sarah.mitchell@email.com',
    phone: '(832) 555-1234',
    address: '4520 Westheimer Rd',
    city: 'Houston',
    state: 'TX',
    zipCode: '77027',
    skills: ['ICU', 'ER', 'Med-Surg', 'Cardiology', 'Telemetry', 'Pediatrics'],
    certifications: ['RN', 'ACLS', 'BLS', 'PALS', 'TNCC', 'CCRN'],
    experience: 8,
    rating: 4.9,
    availability: 'Immediate',
    preferredShift: 'Day (7a-7p)',
    licensureState: 'TX',
    npiNumber: '1234567890',
  },
  placements: [
    {
      id: 'p1',
      status: 'active',
      startDate: '2025-11-01',
      endDate: '2026-05-01',
      role: 'ICU Staff Nurse',
      skills: ['ICU', 'ACLS', 'CCRN'],
      payRate: 52,
      shift: 'Day (7a-7p)',
      facility: {
        id: 'f1',
        name: 'Memorial Regional Medical Center',
        type: 'Hospital',
        address: '3700 Washington Ave',
        city: 'Houston',
        state: 'TX',
        zipCode: '77007',
        phone: '(713) 555-0101',
        rating: 4.5,
        bedCount: 450,
        openPositions: 12,
        requiredSkills: ['ICU', 'ER', 'Med-Surg', 'RN', 'ACLS', 'BLS'],
        contactEmail: 'staffing@memorialregional.org',
        website: 'memorialregional.org',
        specialties: ['Emergency Medicine', 'Critical Care', 'Surgery'],
        parkingInfo: 'Free garage parking, Badge required',
        orientation: '2-day orientation, scrubs provided',
      },
    },
    {
      id: 'p2',
      status: 'completed',
      startDate: '2025-03-15',
      endDate: '2025-09-15',
      role: 'Cardiac Care RN',
      skills: ['Cardiology', 'Telemetry', 'ACLS'],
      payRate: 55,
      shift: 'Night (7p-7a)',
      facility: {
        id: 'f2',
        name: "St. Luke's Health Center",
        type: 'Hospital',
        address: '6720 Bertner Ave',
        city: 'Houston',
        state: 'TX',
        zipCode: '77030',
        phone: '(713) 555-0202',
        rating: 4.8,
        bedCount: 650,
        openPositions: 8,
        requiredSkills: ['Cardiology', 'OR', 'Neurology', 'RN', 'CCRN', 'ACLS'],
        contactEmail: 'hr@stlukes.org',
        website: 'stlukes.org',
        specialties: ['Cardiac Surgery', 'Neurosurgery', 'Transplant'],
        parkingInfo: 'Valet available, Surface lot B',
        orientation: '3-day orientation, housing stipend available',
      },
    },
    {
      id: 'p3',
      status: 'pending',
      statusLabel: 'Waiting for Clearance',
      activityTypeId: 1,
      activityStatusId: 1,
      startDate: '2026-06-01',
      endDate: '2026-12-01',
      role: 'Pediatric RN',
      skills: ['Pediatrics', 'PALS', 'BLS'],
      payRate: 48,
      shift: 'Day (7a-7p)',
      facility: {
        id: 'f3',
        name: "Texas Children's Hospital",
        type: "Children's Hospital",
        address: '6621 Fannin St',
        city: 'Houston',
        state: 'TX',
        zipCode: '77030',
        phone: '(832) 555-0303',
        rating: 4.9,
        bedCount: 800,
        openPositions: 15,
        requiredSkills: ['Pediatrics', 'NICU', 'PICU', 'RN', 'PALS', 'BLS'],
        contactEmail: 'travelnurse@texaschildrens.org',
        website: 'texaschildrens.org',
        specialties: ['Pediatric Surgery', 'Neonatology', 'Pediatric Cardiology'],
        parkingInfo: 'Garage parking $8/day',
        orientation: '1-week orientation, mentorship program',
      },
    },
    {
      id: 'p4',
      status: 'completed',
      startDate: '2024-08-01',
      endDate: '2025-02-01',
      role: 'OR Circulator',
      skills: ['ICU', 'Cardiology', 'CCRN'],
      payRate: 58,
      shift: 'Day (7a-7p)',
      facility: {
        id: 'f6',
        name: 'Houston Methodist',
        type: 'Hospital',
        address: '6565 Fannin St',
        city: 'Houston',
        state: 'TX',
        zipCode: '77030',
        phone: '(713) 555-0606',
        rating: 4.8,
        bedCount: 900,
        openPositions: 20,
        requiredSkills: ['ICU', 'Cardiology', 'OR', 'Telemetry', 'RN', 'ACLS', 'CCRN'],
        contactEmail: 'staffing@houstonmethodist.org',
        website: 'houstonmethodist.org',
        specialties: ['Cardiovascular', 'Neuroscience', 'Orthopedics', 'Oncology'],
        parkingInfo: 'Garage parking, Badge access',
        orientation: '3-day orientation, Magnet facility',
      },
    },
    {
      id: 'p5',
      status: 'cancelled',
      startDate: '2025-01-01',
      endDate: '2025-04-01',
      role: 'ER Travel Nurse',
      skills: ['ER', 'TNCC', 'ACLS'],
      payRate: 60,
      shift: 'Night (7p-7a)',
      facility: {
        id: 'f7',
        name: 'Ben Taub Hospital',
        type: 'Hospital',
        address: '1504 Taub Loop',
        city: 'Houston',
        state: 'TX',
        zipCode: '77030',
        phone: '(713) 555-0707',
        rating: 4.3,
        bedCount: 350,
        openPositions: 18,
        requiredSkills: ['ER', 'ICU', 'Med-Surg', 'Psych', 'RN', 'TNCC', 'ACLS'],
        contactEmail: 'hr@bentaub.org',
        website: 'bentaub.org',
        specialties: ['Trauma', 'Emergency Medicine', 'Psychiatry'],
        parkingInfo: 'Street parking, Lot C available',
        orientation: '2-day trauma-focused orientation',
      },
    },
  ],
};
